<template>
  <div class="overlay-full overlay-overdue-course" :style="{ display: show ? 'block' : '' }">
    <div class="overlay-content">
      <p class="title">
        Your course "<span class="overdue-course-name">{{ courseName }}</span>" is overdue!
      </p>
      <div>
        <a :href="courseAttend" class="btn btn-primary overdue-course-attend" data-answer="yes">View course</a>
        <a href="#" class="btn btn-light overdue-course-reject" data-answer="no" @click="reject">Close</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import CustomButton from "../Button.vue"

export default {
  name: "OverlayCourseOverdue",
  components: {
    CustomButton
  },
  data() {
    return {
      show: false,
      courseName: '',
      courseAttend: ''
    }
  },
  async mounted() {
    try {
      const response = await axios.get(window.courseUrl.overdueChecker);
      const data = response.data;

      if (data) {
        const url = window.courseUrl.preview.replace(':id', data.id);

        this.show = true;
        this.courseName = data.name;
        this.courseAttend = url;
      }
    } catch (error) {
      new Noty({
        type: "warning",
        text: 'Something happened',
      }).show();
    }
  },
  methods: {
    reject(event) {
      event.preventDefault();
      this.show = false
    }
  }
}
</script>
